import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import basketballLogo from "./images/basketball.png";
import "./Register.css";
import "./variables.css";
import API_URL from "./config";
import useAuthDarkTheme from "./useAuthDarkTheme";

const Register = () => {
  const [formData, setFormData] = useState({ username: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [characterErrors, setCharacterErrors] = useState({});

  const CHARACTER_LIMITS = {
    username: { min: 3, max: 20 },
    email: { min: 5, max: 40 },
    password: { min: 8, max: 32 }
  };

  useAuthDarkTheme();

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    
    // Validate all character limits
    const errors = {};
    Object.keys(CHARACTER_LIMITS).forEach((field) => {
      const value = formData[field];
      const limits = CHARACTER_LIMITS[field];
      if (value.length < limits.min) {
        errors[field] = `${field} must be at least ${limits.min} characters`;
      } else if (value.length > limits.max) {
        errors[field] = `${field} cannot exceed ${limits.max} characters`;
      }
    });
    
    if (Object.keys(errors).length > 0) {
      setCharacterErrors(errors);
      return;
    }

    try {
      const response = await fetch(`${API_URL}/api/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        const data = await response.json();
        setError(data.detail || "Server error");
        return;
      }

      const data = await response.json();
      const user = data.user || {};
      
      // Store user data and auth token if available
      localStorage.setItem("user", JSON.stringify(user));
      if (data.access_token) {
        localStorage.setItem("access_token", data.access_token);
      }
      
      // Switch to login after successful registration
      navigate("/saves")

    } catch (err) {
      setError("Server error: " + (err.message || ""));
    }
  };

  return (
    <div className="register-wrapper">
      <div className="register-header">
        <img src={basketballLogo} alt="Logo" className="logo" />
        <h1 className="logo-text">Courtside</h1>
      </div>

      <div className="register-titles">
        <h2 className="register-title">Sign Up</h2>
        <p className="register-subtitle">Join the ultimate basketball community.</p>
      </div>

      <div className="register-container">
        <form onSubmit={handleSubmit} className="register-form">
          {/* Username field */}
          <label htmlFor="username" className="input-label">
            Username
          </label>
          <input
            id="username"
            name="username"
            type="text"
            placeholder="Username"
            value={formData.username}
            onChange={handleChange}
            maxLength={CHARACTER_LIMITS.username.max}
            required
          />
          {characterErrors.username && <p className="character-error">{characterErrors.username}</p>}

          {/* Email field */}
          <label htmlFor="email" className="input-label">
            Email
          </label>
          <input
            id="email"
            name="email"
            type="email"
            placeholder="example@gmail.com"
            value={formData.email}
            onChange={handleChange}
            maxLength={CHARACTER_LIMITS.email.max}
            required
          />
          {characterErrors.email && <p className="character-error">{characterErrors.email}</p>}

          {/* Password field */}
          <label htmlFor="password" className="input-label">
            Password
          </label>
          <input
            id="password"
            name="password"
            type="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleChange}
            maxLength={CHARACTER_LIMITS.password.max}
            required
          />
          {characterErrors.password && <p className="character-error">{characterErrors.password}</p>}
          <p className="character-hint">Password must be 8-32 characters</p>

          <button type="submit" className="register-button">
            Sign Up
          </button>
        </form>

        {error && <p className="error-message">{error}</p>}

        <p className="signup-text">
          Already have an account?{" "}
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              navigate("/login");
            }}
          >
            Log In
          </a>
        </p>
      </div>
    </div>
  );
};

export default Register;
